var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.6,
    height: 77.6,
    viewBox: "0 0 77.6 77.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Price_Target",
    "data-name": "Price Target",
    transform: "translate(-45 -45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22176",
    "data-name": "Path 22176",
    d: "M233.638,188.131h-5.508a4.131,4.131,0,1,0,0,8.261h2.754a4.131,4.131,0,1,1,0,8.262H224M229.508,184v4.131m0,20.654v-4.131",
    transform: "translate(-145.708 -112.592)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22177",
    "data-name": "Path 22177",
    d: "M110.292,140.584A30.292,30.292,0,1,0,80,110.292,30.292,30.292,0,0,0,110.292,140.584Z",
    transform: "translate(-26.492 -26.492)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22178",
    "data-name": "Path 22178",
    d: "M83.8,108.584V119.6M48,83.8H59.015M83.8,59.015V48m24.784,35.8H119.6",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricing);
export default __webpack_public_path__ + "static/media/pricing.3414a8dc7b63543cedddc0f5ba8db69a.svg";
export { ForwardRef as ReactComponent };